import { clsx } from 'clsx'
import { type FC } from 'react'

import { CartIntermediateAdBanner } from '../../CartIntermediateAdBanner/CartIntermediateAdBanner'
import { useCartIntermediateContext } from '../../context/CartIntermediateContext'
import { CartIntermediateCtaButtons } from '../CartIntermediateCtaButtons/CartIntermediateCtaButtons'
import { CartIntermediateProductInfo } from '../CartIntermediateProductInfo/CartIntermediateProductInfo'

type CartIntermediateProductWithButtonsSectionType = {
  handleClose: () => void
}
export const CartIntermediateProductWithButtonsSection: FC<
  CartIntermediateProductWithButtonsSectionType
> = ({ handleClose }) => {
  const { product, recommendedProduct } = useCartIntermediateContext()

  return (
    <div className="flex flex-col gap-x-4 tablet:flex-row tablet:flex-wrap tablet:justify-between">
      <div className="flex-1">
        <CartIntermediateProductInfo product={product} />
      </div>
      <div
        className={clsx(
          'flex flex-1 justify-center',
          recommendedProduct
            ? 'order-4 tablet:-order-none'
            : 'order-3 tablet:order-2',
        )}
      >
        <CartIntermediateAdBanner />
      </div>
      {recommendedProduct ? (
        <div className="py-2 tablet:w-full">
          <CartIntermediateProductInfo product={recommendedProduct} />
        </div>
      ) : null}
      <div
        className={clsx(
          'tablet:w-full',
          !recommendedProduct && 'order-2 tablet:order-3',
        )}
      >
        <CartIntermediateCtaButtons handleClose={handleClose} />
      </div>
    </div>
  )
}
